"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnstyledButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _UnstyledButtonMixin = require("../../mixins/components/UnstyledButtonMixin");
/**
 * A button element with default browser styles overwritten to produce a style
 * agnostic button.
 *
 * This component is intended to be used to provide an accessible element for performing
 * actions. For instance, `onClick` on a `span` is not accessible to keyboard-based users without
 * additional work such as having appropriate keystroke event listeners (i.e. onKeyDown for Enter).
 *
 * By utilizing a `button` DOM node as a wrapper to an `span`, the click event listener,
 * subsequently moved to the button, is invoked natively by the browser without any
 * additional attributes necessary for keyboard-based interactions.
 *
 * See [MDN documentation on `button`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button)
 * for a list of permitted content.
 *
 * @since 8.30.0
 */
var UnstyledButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "UnstyledButton",
  componentId: "c11n-8-107-0__sc-13jpj60-0"
})(["", ""], _UnstyledButtonMixin.UnstyledButtonMixin);
exports.UnstyledButton = UnstyledButton;
UnstyledButton.displayName = 'UnstyledButton';
UnstyledButton.defaultProps = {
  type: 'button'
};

/** @component */